import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  defaultLocale: "en",
  locales: ["en", "fa"],
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- disable unnecessary any type
export const { Link, redirect, usePathname, useRouter, getPathname }: any =
  createNavigation(routing);
